import React from 'react'

function useForceUpdate() {
  const [ignored, rerender] = React.useReducer(x => x + 1, 0)
  return { rerender }
}

export default useForceUpdate
